import { getDocument } from '_acaSrc/utility/DOM';
import { FORM_SELECTORS } from './MergeAccountsConstants';

export default class ValidationService {
    static isEmpty(value) {
        return value === '' || value === undefined || value === null;
    }

    static focusElement(selector) {
        const element = getDocument().querySelector(selector);
        element?.focus();
    }

    static validateCredentials(userName, password) {
        if (ValidationService.isEmpty(userName)) {
            ValidationService.focusElement(FORM_SELECTORS.USERNAME);
            return { isValid: false, field: 'username' };
        }

        if (ValidationService.isEmpty(password)) {
            ValidationService.focusElement(FORM_SELECTORS.PASSWORD);
            return { isValid: false, field: 'password' };
        }

        return { isValid: true };
    }
}
